import React from "react";
import { Button, Empty, Space, Switch } from "antd";
import confirmBox from "../../CoreComponents/confirmBox";
import { deleteBanner, updateBanner } from "./api";
import { HiddenTag, ListRow, linkLabel } from "./bannerTags";
import { notify } from "./notify";

export default function SectionBanners({ banners, onChanged, onEdit }) {
  const toggle = async (banner, on) => {
    if (notify(await updateBanner(banner.id, { isActive: on }), on ? "Banner on" : "Banner off")) onChanged();
  };
  const remove = (banner) =>
    confirmBox({
      title: "Delete this banner?",
      yesLabel: "Delete",
      onYes: async () => notify(await deleteBanner(banner.id), "Banner deleted") && onChanged(),
    });
  if (!banners.length) return <Empty description="No banners in this section yet" />;
  return banners.map((banner) => (
    <ListRow key={banner.id}>
      <img src={banner.image} alt="" style={{ width: 96, height: 96, objectFit: "cover", borderRadius: 8 }} />
      <div style={{ flex: 1, minWidth: 160 }}>{linkLabel(banner)}</div>
      <HiddenTag reason={banner.hidden_now} />
      <Switch checked={banner.is_active} onChange={(on) => toggle(banner, on)} />
      <Space>
        <Button onClick={() => onEdit(banner)}>Edit</Button>
        <Button danger onClick={() => remove(banner)}>Delete</Button>
      </Space>
    </ListRow>
  ));
}
